/**
 * SKINER Card Swatches
 * Handles color swatch clicks on product cards — swaps the card image.
 */

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.skiner-card-swatch');
  if (!swatch) return;

  const swatchGroup = swatch.closest('.skiner-card-swatches');
  const cardWrapper = swatch.closest('.card-wrapper');
  if (!cardWrapper) return;

  // Deactivate all swatches in this card
  swatchGroup.querySelectorAll('.skiner-card-swatch').forEach((s) => {
    s.classList.remove('skiner-card-swatch--active');
    s.setAttribute('aria-pressed', 'false');
  });

  // Activate clicked swatch
  swatch.classList.add('skiner-card-swatch--active');
  swatch.setAttribute('aria-pressed', 'true');

  // Swap card image
  const newSrc = swatch.dataset.imgSrc;
  if (!newSrc) return;

  const img = cardWrapper.querySelector('.card__media img');
  if (img) {
    img.srcset = '';
    img.src = newSrc;
  }
});
